import { useState, useEffect } from "react";
import classNames from "classnames";

import checkMarkIcon from "/assets/check-mark.svg";

export default function Checkbox({
  children,
  onChange,
  value,
  errors = [],
}) {
  const [isValid, setIsValid] = useState(errors.length == 0);

  useEffect(() => {
    setIsValid(errors.length === 0);
  }, [errors]);

  const handleChange = () => {
    if (typeof onChange === "function")
      onChange(!value);

    setIsValid(true);
  };

  return (
    <div className="inpt-checkbox-wrapper">
      {/* A real input so the browser handles the keyboard, the announced state,
          and its rule that a label ignores clicks landing on interactive content
          inside it — which is what lets the privacy-policy link be followed
          without ticking the box. */}
      <label className="inpt-checkbox-line">
        <input
          type="checkbox"
          className="inpt-checkbox-input"
          checked={!!value}
          onChange={handleChange}
        />

        <div className={classNames(
          "inpt-checkbox",
          {
            "inpt-checkbox--checked": !!value,
            "inpt-checkbox--error": !isValid,
          }
        )}>
          <img src={checkMarkIcon} alt="" />
        </div>

        <div className="inpt-checkbox-content">
          {children}
        </div>
      </label>

      <div className="inpt-checkbox-notes">
        {!isValid && errors.map((error, index) => (
          <label key={index} className="lbl lbl--error">{error}</label>
        ))}
      </div>
    </div>
  );
}
